<template>
  <div class="loginall">
    <!-- <el-form
      v-if="true"
      ref="form"
      class="loginall"
      :model="loginDate"
      :rules="rules"
    >
      <el-form-item prop="name">
        <el-input
          v-model="loginDate.name"
          placeholder="邮箱/手机号"
          class="login-form-input"
        ></el-input>
      </el-form-item>
      <el-form-item prop="imgcode">
        <el-input placeholder="请输入右侧验证码" v-model="registerDate.imgCode">
          <template slot="append"
            ><img ref="codeimg" :src="imgcode" @click="getImgCode" alt=""
          /></template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="usersub">提交</el-button>
      </el-form-item>
      <el-form-item class="elseoption">
        <div class="goelse">
          <router-link to="/login">返回登录</router-link>
        </div>
      </el-form-item>
    </el-form> -->
    <div class="loginWrap clearfix">
      <div class="loginLeft fl">
        <img class="bg1" src="~img/account/bg1.png" alt="" />
        <img
          @click="gohome"
          class="logotop"
          src="~img/account/logotop.png"
          alt=""
        />
        <div class="logoInfo">
          <img src="~img/account/email.png" alt="" />
          <p>kefu@blackrockread.com</p>
          <img src="~img/account/phone2.png" alt="" />
          <p>010-82156292</p>
          <img src="~img/account/qq2.png" alt="" />
          <p>2984543729 / 2814551419</p>
        </div>
      </div>
      <div class="loginRight fl">
        <img class="bg2" src="~img/account/bg2.png" alt="" />
        <el-form
          ref="changepass"
          :model="forgetDate"
          :rules="rules"
          style="height:555px"
        >
          <h2>忘记密码</h2>
          <el-form-item prop="mobile">
            <el-input
              v-model="forgetDate.mobile"
              @focus="getFocus('changepass', 'mobile')"
              placeholder="手机号"
              class="login-form-input"
            ></el-input>
          </el-form-item>
          <el-form-item prop="imgCode">
            <el-input
              placeholder="请输入右侧验证码"
              @focus="getFocus('changepass', 'imgCode')"
              v-model="forgetDate.imgCode"
            >
              <template slot="append"
                ><img ref="codeimg" :src="imgcode" @click="getImgCode" alt=""
              /></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="getcodebox">
              <el-input
                @focus="getFocus('changepass', 'code')"
                placeholder="获取验证码"
                v-model="forgetDate.code"
                class="getcode"
              >
              </el-input>
              <div class="getmycode" v-show="isclick" @click="getCode">
                获取
              </div>
              <div
                class="getmycode isnoneclick"
                v-show="!isclick"
                width="117px"
              >
                重新发送 ({{ timecount }}s)
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="forgetDate.password"
              @focus="getFocus('changepass', 'password')"
              class="login-form-input"
              placeholder="密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="repeatPassword">
            <el-input
              v-model="forgetDate.repeatPassword"
              @focus="getFocus('changepass', 'repeatPassword')"
              class="login-form-input"
              placeholder="再次确认密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="usersub" @click="forgetSubmit('changepass')"
              >提交</el-button
            >
          </el-form-item>
          <el-form-item class="elseoption">
            <div class="goelse">
              <router-link to="/login">返回登录</router-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile, isPwd, encryptStr } from "utils/core/kernel";
import { getCode, forget } from "apiurl/login";
import { BENDI } from "apiurl/index";
export default {
  data() {
    var validateName = (rule, value, callback) => {
      if (isMobile(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号"));
      }
    };
    var validatePass = (rule, value, callback) => {
      if (isPwd(value)) {
        callback();
      } else {
        callback(new Error("请输入6-20位字母数字符号中的两种"));
      }
    };
    return {
      forgetDate: {
        mobile: "",
        imgCode: null,
        code: null,
        password: null,
        repeatPassword: null
      },
      imgcode: "", //图片验证码
      timestamp: null, // 保存时间戳
      isclick: true, //是否可发送验证码
      timecount: 60, //倒计时秒数
      timer: null, //计时对象
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateName, trigger: "blur" }
        ],
        imgCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ],
        repeatPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.$nextTick(() => {
      /* 获取验证码 */
      this.getImgCode();
    });
  },
  methods: {
    /* 获取图片验证码 */
    getImgCode() {
      let timestamp = new Date().getTime();
      this.timestamp = timestamp;
      this.$refs.codeimg.setAttribute(
        "src",
        `${BENDI}/auth/image/captcha?timestamp=${timestamp}`
      );
    },
    /* 获取手机验证码 */
    async getCode() {
      if (this.forgetDate.mobile && this.forgetDate.imgCode) {
        let coderes = await getCode({
          mobile: encryptStr(this.forgetDate.mobile),
          captcha: this.forgetDate.imgCode,
          timestamp: this.timestamp
        });
        if (coderes.success) {
          this.$message({
            message: "短信已发送到您的手机！",
            type: "success"
          });
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.timecount = TIME_COUNT;
            this.isclick = false;
            this.timer = setInterval(() => {
              if (this.timecount > 1 && this.timecount <= TIME_COUNT) {
                this.timecount--;
              } else {
                this.isclick = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          /* 再次点击刷新图片验证码 */
          if (coderes.code === 20004) {
            this.getImgCode();
          }
        }
      } else {
        this.$message.error("请输入手机号和图片验证码");
      }
    },
    /* 更改密码*/
    forgetSubmit(changepass) {
      this.$refs[changepass].validate(valid => {
        if (valid) {
          if (this.forgetDate.repeatPassword === this.forgetDate.password) {
            forget({
              code: this.forgetDate.code,
              mobile: encryptStr(this.forgetDate.mobile),
              password: encryptStr(this.forgetDate.password),
              repeatPassword: encryptStr(this.forgetDate.repeatPassword)
            })
              .then(res => {
                if (res.success) {
                  this.$message({
                    message: "密码更改成功！",
                    type: "success"
                  });
                  this.$router.push("/login");
                }
              })
              .catch(() => {});
          } else {
            this.$message({
              message: "两次密码不一致！",
              type: "error"
            });
          }
        }
      });
    },
    // 移除
    getFocus(changepass, item) {
      this.$refs[changepass].clearValidate(item);
    },
    // 去首页
    gohome() {
      this.$router.push("/");
    }
  }
};
</script>
<style>
.el-input-group__append img {
  display: block;
  width: 80px;
  height: 45px;
  border-radius: 0 4px 4px 0;
}
.getcode .el-input-group__append {
  background: rgba(72, 162, 223, 1);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  color: #fff;
}
.getcodebox {
  position: relative;
}
.getmycode {
  position: absolute;
  cursor: pointer;
  width: 80px;
  height: 46px;
  background: rgba(72, 162, 223, 1);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  color: #fff;
  top: 0px;
  right: 0px;
  text-align: center;
  border-radius: 0 4px 4px 0;
  line-height: 46px;
}
.isnoneclick {
  width: 117px;
}
</style>

<style lang="stylus" scoped>
.el-form
    width 300px
    margin 60px auto 0
    .goelse
        a
            font-size 14px
            color rgba(102, 102, 102, 1)
    .loginelse
        margin-top 40px
        display flex
        justify-content space-between
        a
            width 42px
            height 42px
</style>
